import { Button, CustomMenu } from '@agilize/components-core';
import styled, { css } from 'styled-components';

export const MenuItemHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: ${props => props.theme.fontSizes[3]};
  padding: ${props =>
    `${props.theme.global.gutterSpace * 0.875}px ${props.theme.space[2]}px ${props.theme.global.gutterSpace * 0.875}px ${
      props.hasPaddingLeft ? props.theme.global.gutterSpace * 0.875 : 0
    }px`};
  color: ${props => props.theme.colors.grey900};
  border-radius: ${props => props.theme.forms.borderRadius}px;
  border: 1px solid ${props => props.theme.colors.grey200};
  cursor: pointer;
  transition: background 100ms linear, border 100ms linear;
  margin-top: ${props => props.theme.global.gutterSpace * 0.5}px;

  &:hover {
    background-color: ${props => props.theme.colors.purple100};
    border-color: ${props => props.theme.colors.purple400};
  }

  ${props =>
    props.selected &&
    css`
      font-weight: 600;
    `}

  ${props =>
    props.active &&
    css`
      background-color: ${props => props.theme.colors.purple100};
      border-color: ${props => props.theme.colors.purple400};
      font-weight: 600;
    `}
`;

export const MenuItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  color: ${props => props.theme.colors.grey900};
  margin-right: ${props => props.theme.global.gutterSpace / 2}px;
`;

export const ApplicationTitle = styled.div`
  font-size: ${props => props.theme.fontSizes[3]};
  color: ${props => props.theme.colors.grey900};
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;

export const CustomStyledMenu = styled(CustomMenu)`
  width: 100%;
  border: 1px solid ${props => props.theme.colors.grey200};
`;
